var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSansaninline = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "39.632px",
    height: "33.233px",
    viewBox: "-9 3 60 25",
    stroke: "white",
    strokeWidth: 1,
    fill: "white",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.462,18.622c-3.3,0.07-6.02-2.7-6.08-6.18c-0.06-3.48,2.56-6.36,5.85-6.42c3.3-0.07,6.02,2.7,6.08,6.18       C36.372,15.682,33.752,18.562,30.462,18.622z M11.762,23.982c-3.29,0.07-6.01-2.7-6.07-6.18c-0.06-3.48,2.56-6.36,5.85-6.43       c3.29-0.06,6.01,2.71,6.07,6.19C17.682,21.042,15.062,23.922,11.762,23.982z M30.132,0.002c-5.06,0.1-9.3,3.6-10.83,8.39       c-2.1-1.94-4.86-3.09-7.87-3.02c-6.43,0.12-11.55,5.74-11.43,12.54c0.12,6.8,5.44,12.22,11.87,12.09c5.06-0.1,9.3-3.6,10.83-8.39       c2.1,1.94,4.86,3.08,7.87,3.02c6.43-0.12,11.55-5.74,11.43-12.54C41.882,5.292,36.562-0.128,30.132,0.002z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSansaninline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Sansan.inline.74efe38a1de1c514b41d9515302562fc.svg";